/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * 31 Milk St # 960789 Boston, MA 02196 USA.
 *
 * Copyright (c) 2023-2026 (original work) Open Assessment Technologies SA;
 */
import * as Types from '../../core/model/types.js'; // eslint-disable-line no-unused-vars
import { actionsList } from '@/core/utils/consts';
import { postAcs } from '@/core/api/api';

/**
 * Makes an ACS request with the given interactions
 * @param {String} action
 * @param {Types.Interaction[]} interactions
 * @returns {Promise} - Request promise
 */
export function postBulkAcs(action, interactions = []) {
    if (!action || !actionsList[action] || !interactions.length) {
        return Promise.reject();
    }
    /** @type {Types.ACSInteraction[]} */
    const actions = interactions.map(interaction => ({
        resource_link_id: interaction.resourceLinkId || '',
        delivery_execution_id: interaction.deliveryExecution.id,
        userName: interaction.user.name,
        sub: interaction.user.id,
        action,
        incident_time: new Date().toISOString()
    }));

    return postAcs(actions);
}
